import React from 'react';
import { Modal, Segment } from 'semantic-ui-react';
import { shape, func } from 'prop-types';

import RequestContent from '../RequestContent/RequestContent';

const ModalBotRequest = props => {
  const { close, message } = props;
  return (
    <Modal open closeOnDimmerClick size="tiny" onClose={close} closeIcon>
      <Modal.Header>Consult Request</Modal.Header>
      <Modal.Content as={Segment} basic>
        <RequestContent message={message} />
      </Modal.Content>
    </Modal>
  );
};

ModalBotRequest.propTypes = {
  message: shape({}).isRequired,
  close: func.isRequired,
};

export default ModalBotRequest;
